module.exports = __webpack_public_path__ + "689d7c67231bea596884a2e7bf9ab14f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/unicorn-crown-s.png
// module id = 2956
// module chunks = 0